import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { JsonService } from '../_services/json.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from "@angular/common";
import { ConfirmationDialogService } from '../_services/confirmation-dialog.service';
import { DialogService } from '../dialog/dialog.service';
import { TranslateService } from '@ngx-translate/core';
import { StringSwitchService } from '../_helpers/string-switch.service';
import { LoadingService } from '../_services/loading.service';
import { LoggerService } from '../_services/logger.service';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { forkJoin, of, pairs } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { Group } from '../_models';
import { GlobalService } from '../_services/global.service';

@Component({
  selector: 'app-group-list',
  templateUrl: './group-list.component.html',
  styleUrls: ['./group-list.component.scss']
})
export class GroupListComponent implements OnInit {
  public listaPaises: Array<any> = [];
  public listaRegiao: Array<any> = [];
  public listaGrupos: Array<any> = [];
  public listaUsuarios: Array<any> = [];
  public listaItens: Group[] = [];
  public listaShowItens: Group[] = [];
  public flatList: any[] = [];
  public currentPage = 1;
  public pageSize = 15;
  public loading: boolean = false;
  public totalItems = 0;
  public acesso: string = 'operador';
  public groupName: string = '';
  public groupPeso: string = '';
  public regiaoSelecionada: string = '';
  public showAddGroup: boolean = false;
  public paisSelecionado: string = '';
  public grupoSelecionado: string = '';
  public usuarioSelecionado: string = '';
  public selectedGroupId: string = 'new';
  public showButtonNovoGrupo: boolean = false;
  public isAdminUser: boolean = false;
  public isAdminGrupoUser: boolean = false;
  public isAdminGlobalGrupoUser: boolean = false;
  selectedMap: { [id: string]: boolean } = {};

  get selectedIds() { return Object.keys(this.selectedMap).filter(k => this.selectedMap[k]); }
  get someSelected() { return this.selectedIds.length > 0; }
  get allSelected() {
    const active = this.flatList.filter(i => i.isActive !== false);
    return active.length > 0 && active.every(i => !!this.selectedMap[i.idGrupoRegion]);
  }

  private _allRegioes: any[] = [];

  public filtro: any = {
    status: 'W',
    usuario: '',
    data: '',
    pais: '',
    cidade: '',
    pdv: '',
    ano: '',
    mes: '',
    regiao: '',
    provedor: '',
    envio: '',
    grupos: '',
    selecionarTodos: '',
    responsavel : '',
    filename : ''
  };


  constructor(
    private jsonService: JsonService,
    private route: ActivatedRoute,
    private location: Location,
    private confirmationDialog: ConfirmationDialogService,
    private dialogService: DialogService,
    private router: Router,
    private loadingService: LoadingService,
    private stringSwitchService: StringSwitchService,
    private logger: LoggerService,
    private translate: TranslateService,
    private globalService: GlobalService,
  ) { }


  ngOnInit(): void {

    this.limparCampos();
    this.limparFiltro();
    this.verificaAcesso();
    this.loadCombosList();
  }

  private verificaAcesso() {
    let user = sessionStorage.getItem('username'); 
    this.isAdminUser = this.globalService.isAdmin();
    this.isAdminGrupoUser = this.globalService.isAdminGrupo();
    this.isAdminGlobalGrupoUser = this.globalService.isAdminGlobalGrupo();
    this.showButtonNovoGrupo = (this.isAdminUser || !this.isAdminGrupoUser || this.isAdminGlobalGrupoUser);
  }


  private loadCombosList() {
    const user = sessionStorage.getItem('username');
    this.loadingService.show();
    forkJoin({
      groups:    this.jsonService.getGroupListWithUserResp(user),
      countries: this.jsonService.listCountry(),
      regions:   this.jsonService.getRegiao(),
      users:     this.jsonService.listGroupUsers()
    }).subscribe(
      ({ groups, countries, regions, users }) => {
        this.listaGrupos   = groups.sort((a: any, b: any) => a.name.localeCompare(b.name));
        this.listaPaises   = countries.sort((a: any, b: any) => a.name.localeCompare(b.name));
        this._allRegioes   = regions.sort((a: any, b: any) => a.name.localeCompare(b.name));
        this.listaRegiao   = [...this._allRegioes];
        this.listaUsuarios = users.sort((a: any, b: any) => a.email.localeCompare(b.email));
        this.listaItens    = groups;
        this.listaItens.forEach(g => (g as any).expanded = false);
        this.listaShowItens = this.listaItens;
        this.flattenData();
        this.flatList = this.flatList.filter(item => item.isActive !== false);
        this.loadingService.hide();
      },
      erro => {
        this.loadingService.hide();
        this.logger.error('Erro ao carregar dados iniciais', erro);
      }
    );
  }

   carregaFiltroRegioes(idPais: string) {
    this.listaRegiao = idPais
      ? this._allRegioes.filter(r => r.countryId === idPais)
      : [...this._allRegioes];
  }

  novoGrupo() {
    this.router.navigate(['/grupo-detalhe', '', '', 'incluir']);
  }


  handleGroupCreationResponse(resp: any) {
    let auxChance = Number(resp.regionTotalChance);
    let smsgInferior = 'A soma dos percentuais de distribuição dos grupos é inferior a 100%. Isso poderá causar falhas ou lacunas na distribuição de receitas. Percentual atual: ';
    let smsgSucesso = 'Grupo criado com sucesso!';

    if (auxChance < 100) {
      let title = this.translate.instant('Éxito') + '!';
      let message = this.translate.instant(smsgInferior) + resp.regionTotalChance + '%';
      this.dialogService.abrirDialog('aviso', title, message);
    } else {
      let title = this.translate.instant('Éxito') + '!';
      let message = this.translate.instant(smsgSucesso);
      this.dialogService.abrirDialog('aviso', title, message);
    }

    this.filtro.pais   = this.paisSelecionado;
    this.filtro.regiao = this.regiaoSelecionada;
    this.filtro.grupo  = this.grupoSelecionado;
    this.filtro.usuario = this.usuarioSelecionado;
    this.loadGoups(true);
    this.limparCampos();
    this.showAddGroup = false;
    this.loadingService.hide();
  }
  
  
  loadGoups(filtra: boolean = false) {
    let user = sessionStorage.getItem('username');
    this.loadingService.show();
    this.jsonService.getGroupListWithUserResp(user).subscribe(
      (resp: Group[]) => {
        this.listaItens = resp;
        this.listaItens.forEach(g => (g as any).expanded = false);
           this.listaShowItens = this.listaItens;
           this.flattenData(); 
           this.loadingService.hide();
        // }
      },
      erro => {
        this.loadingService.hide();
        this.logger.error('Erro ao carregar grupos', erro);
      }
    );
  }

  private flattenData() {
    this.flatList = [];
    const weightSums = new Map<string, number>();

    this.listaShowItens.forEach(group => {
      group.groupCountryRegions.forEach(gcr => {
        const key = `${gcr.countryId}-${gcr.regionId || ''}`;
        const currentSum = weightSums.get(key) || 0;
        weightSums.set(key, currentSum + gcr.weight);
      });
    });

    this.listaShowItens.forEach(group => {
      group.groupCountryRegions.forEach(gcr => {
        const key = `${gcr.countryId}-${gcr.regionId || ''}`;
        const weightSum = weightSums.get(key) || 0;

        this.flatList.push({
          countryId: gcr.countryId,
          regionId: gcr.regionId,
          idGrupo: group.id,
          idGrupoRegion: gcr.idGrupoRegion,
          name: group.name,
          country: this.getCountryName(gcr.countryId),
          region: this.getRegionName(gcr.regionId),
          weight: gcr.weight,
          userMembers: gcr.groupCountryRegionUsers ? gcr.groupCountryRegionUsers.length : 0,
          gcr: gcr,
          weightSum: weightSum,
          isActive: gcr.isActive !== false
        });
      });
    });

    this.flatList = this.flatList.sort((a, b) => {
      const nameA = a.name.toLowerCase();
      const nameB = b.name.toLowerCase();
      if (nameA < nameB) return -1;
      if (nameA > nameB) return 1;

      const countryA = a.country.toLowerCase();
      const countryB = b.country.toLowerCase();
      if (countryA < countryB) return -1;
      if (countryA > countryB) return 1;

      const regionA = a.region.toLowerCase();
      const regionB = b.region.toLowerCase();
      if (regionA < regionB) return -1;
      if (regionA > regionB) return 1;

      return 0;
    });
   
  }

  editarGrupo(id: string, idGrupoRegion: string) {
    this.router.navigate(['/grupo-detalhe', id, idGrupoRegion,  'editar']);
  }

  async removeGroup(groupid: string, gcrToRemove: any) {
    let title = this.translate.instant('Atenção') + '!';
    let texto = this.translate.instant('Tem certeza de que deseja remover esta associação de país/região do grupo?');
    const confirmed = await this.confirmationDialog.confirm(title, texto);

    if (!confirmed) return;

    const group = this.listaItens.find(g => g.id === groupid);
    if (!group) {
      this.logger.error('Não foi possível encontrar o grupo para remover a associação.');
      return;
    }

    const payload = {
      id: group.id,
      name: group.name,
      userMembers: group.userMembers || 0,
      groupCountryRegions: group.groupCountryRegions.filter(
        gcr => !(gcr.countryId === gcrToRemove.countryId && gcr.regionId === gcrToRemove.regionId)
      )
    };

    this.loadingService.show();
    this.jsonService.putGroupUpdateUrl(payload).subscribe(
      () => {
        let successTitle = this.translate.instant('Éxito') + '!';
        let successMessage = this.translate.instant('Associação removida com sucesso!');
        this.dialogService.abrirDialog('aviso', successTitle, successMessage);
        this.loadGoups(true);
        this.loadingService.hide();
      },
      erro => {
        this.logger.error('Erro ao remover associação do grupo', erro);
        let errorTitle = this.translate.instant('Atenção') + '!';
        let errorMessage = this.translate.instant('Não foi possível remover a associação, pode haver receitas associadas.');
        this.dialogService.abrirDialog('aviso', errorTitle, errorMessage);
        this.loadingService.hide();
      }
    );
  }

  async toggleActiveGroupCountryRegion(item: any) {
    const isDeactivating = item.isActive !== false;
    const title = this.translate.instant('Atenção') + '!';
    const msg = isDeactivating
      ? this.translate.instant('Tem certeza de que deseja desativar esta associação de país/região?')
      : this.translate.instant('Deseja reativar esta associação de país/região?');
    const confirmed = await this.confirmationDialog.confirm(title, msg);
    if (!confirmed) return;

    const user = sessionStorage.getItem('username') ?? '';
    this.loadingService.show();
    this.jsonService.toggleActiveGroupCountryRegion({ id: item.idGrupoRegion, isActive: !isDeactivating, updatedBy: user }).subscribe(
      () => {
        this.loadingService.hide();
        this.loadGoups(true);
      },
      erro => {
        this.loadingService.hide();
        this.logger.error('Erro ao alterar status da associação', erro);
        const errTitle = this.translate.instant('Atenção') + '!';
        const errMsg = erro?.error?.message
          || this.translate.instant('Não é possível desativar. Existem prescrições ativas vinculadas a esta associação.');
        this.dialogService.abrirDialog('aviso', errTitle, errMsg);
      }
    );
  }

  carregarListaRegiao() {
    this.carregaFiltroRegioes(this.paisSelecionado);
  }

  limparSelecao() { this.selectedMap = {}; }

  onToggleItem(id: string, checked: boolean) {
    this.selectedMap = { ...this.selectedMap, [id]: checked };
  }

  toggleSelectAll() {
    const active = this.flatList.filter(i => i.isActive !== false);
    const next: { [id: string]: boolean } = {};
    if (!this.allSelected) active.forEach(i => next[i.idGrupoRegion] = true);
    this.selectedMap = next;
  }

  async desativarSelecionados() {
    const ids = this.selectedIds;
    const title = this.translate.instant('Atenção') + '!';
    const msg = this.translate.instant(`Confirma a desativação de ${ids.length} associação(ões)?`);
    const confirmed = await this.confirmationDialog.confirm(title, msg);
    if (!confirmed) return;

    const user = sessionStorage.getItem('username') ?? '';
    this.loadingService.show();
    forkJoin(ids.map(id =>
      this.jsonService.toggleActiveGroupCountryRegion({ id, isActive: false, updatedBy: user })
    )).subscribe({
      next: () => {
        this.selectedMap = {};
        this.loadingService.hide();
        this.loadGoups(true);
      },
      error: (erro) => {
        this.loadingService.hide();
        const errTitle = this.translate.instant('Atenção') + '!';
        const errMsg = erro?.error?.message
          || this.translate.instant('Não foi possível desativar uma ou mais associações.');
        this.dialogService.abrirDialog('aviso', errTitle, errMsg);
      }
    });
  }

  atualizaFiltro() {
    this.selectedMap = {};
    let filteredGroups = this.listaItens;

    if (this.filtro.search) {
      filteredGroups = filteredGroups.filter(group => group.name.toLowerCase().includes(this.filtro.search.toLowerCase()));
    }

    if (this.filtro.grupo) {
       filteredGroups = filteredGroups.filter(group => group.id === this.filtro.grupo);
    }

    if (this.filtro.pais) {
      this.carregaFiltroRegioes(this.filtro.pais);
      if (this.filtro.regiao && !this._allRegioes.some(r => r.id === this.filtro.regiao && r.countryId === this.filtro.pais)) {
        this.filtro.regiao = '';
      }
      filteredGroups = filteredGroups
        .map(group => ({
          ...group,
          groupCountryRegions: group.groupCountryRegions.filter(gcr => gcr.countryId === this.filtro.pais)
        }))
        .filter(group => group.groupCountryRegions.length > 0);
      } else {
        this.listaRegiao = [...this._allRegioes];
    }

    if (this.filtro.regiao) {
        filteredGroups = filteredGroups
        .map(group => ({
            ...group,
            groupCountryRegions: group.groupCountryRegions.filter(gcr => gcr.regionId === this.filtro.regiao)
        }))
        .filter(group => group.groupCountryRegions.length > 0);
    }

    if (this.filtro.usuario) {
      const filtroUsuarioId = this.filtro.usuario ? this.filtro.usuario.toString().toLowerCase() : null;
      filteredGroups = filteredGroups
        .map(group => ({
            ...group,
            groupCountryRegions: group.groupCountryRegions.filter(gcr => 
               gcr.groupCountryRegionUsers && 
               gcr.groupCountryRegionUsers.some(gcru => gcru.idUser!= null && gcru.idUser.toLowerCase() === filtroUsuarioId))    
        }))
        .filter(group => group.groupCountryRegions.length > 0);
    }


    this.listaShowItens = filteredGroups;
    this.flattenData();
    this.flatList = this.flatList.filter(item => item.isActive !== false);
    this.currentPage = 1;

  }

    getRegionName(id: string): string {

    if(!id) return 'Nenhuma região selecionada.';

    const region = this.listaRegiao.find(regiao => regiao.id == id);
    return region ? region.name : 'Região não encontrada.';
  }

  getCountryName(id: string): string {
    const country = this.listaPaises.find(pais => pais.id == id);
    return country ? country.name : 'País não encontrado';
  }

  limparCampos() {
      this.groupName = '';
      this.groupPeso = '';
      this.grupoSelecionado = '';
      this.paisSelecionado = '';
      this.regiaoSelecionada = '';
      this.usuarioSelecionado = '';
      this.selectedGroupId = 'new';
      this.showButtonNovoGrupo = false;
  }

  limparFiltro() {
    this.filtro = {
      grupo: '',
      regiao: '',
      pais: '',
      usuario: '',
      search: ''
    };
    this.listaShowItens = this.listaItens;
    this.flattenData();
    this.currentPage = 1; 
  }

  arredondar(valor: number): number {
    return Math.ceil(valor);
  }

  public switchString(value: string): string {
    return this.stringSwitchService.switchString(value);
  }
}